// extracted by mini-css-extract-plugin
module.exports = {"logo":"partners_logo__VIvoj","lg":"partners_lg__b8XpV"};